import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,Form, FormGroup, Label, Button, Modal, ModalHeader, ModalBody
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchOnboardingJobCode, fetchOnboradingProcessList, fetchApplicantLevelDtls } from "store/actions";
import CustomSelect from "components/Common/custom-select";
import { urlEncryptData } from "helpers/crypto_helper";
import Loader from "common/pageLoader";

const Process = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [marksModal, setMarksModal] = useState(false);
  const [selectedMarks, setSelectedMarks] = useState(null);
  const {
    jobCodes,
    processList,
    applicantLevelDtls,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    jobCodes: state.RecruitmentOnboardingReducer?.jobCodes ?? [],
    processList: state.RecruitmentOnboardingReducer?.processList ?? [],
    applicantLevelDtls: state.RecruitmentOnboardingReducer?.applicantLevelDtls ?? [],
    loading: state.RecruitmentOnboardingReducer?.loading,
    error: state.RecruitmentOnboardingReducer?.error,
    success: state.RecruitmentOnboardingReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id    
    const formData = new FormData()
    formData.append('position_id',0)
    formData.append('unit_id',unitId)
    dispatch(fetchOnboardingJobCode(unitId));
    dispatch(fetchOnboradingProcessList(formData))
  }, [dispatch]);


  const statusLabelMap = { 1: 'Pending', 2: 'In Progress', 3: 'Completed' };
  const levelLabelMap = { '1': 'Online Test', '2': 'Technical Assessment', '3': 'Technical Interview', '4': 'Managerial/Behavioral Round', '5': 'Final HR Round' };

  const handleViewMarks = (rowData) => {
    setSelectedMarks(rowData);
    setMarksModal(true);
    const formData = new FormData();
    formData.append('applicant_id', rowData.applicant_id);
    formData.append('unit_id', '');
    dispatch(fetchApplicantLevelDtls(formData));
  };

  const columns = [
    {Header: "S.No",className: "serial-no text-center",Cell: ({ row }) => processList.length - row.index,},
    {
      Header: "Assign",
      className: "text-center",
      Cell: ({ row }) => {
        const applicantId = row.original.applicant_id;
        console.log('applicantId > ',applicantId)
        return (
          <Link to={`/rcrt-onbd-view-appl-process?id=${encodeURIComponent(urlEncryptData(`${applicantId}`))}`}>
            <i className="mdi mdi-account-check text-success font-size-20" />
          </Link>
        );
      },
    },
    {
      Header: "Resume",
      className: "text-center",
      Cell: (cellProps) => {
        const fileUrl = cellProps.row.original.file_path;
        const filePath = `${process.env.REACT_APP_IMAGE_BASE_URL}${fileUrl}`;
        return (
          <div>
            <a href={filePath} target="_blank" rel="noopener noreferrer">
              <i
                className="mdi mdi-file-document font-size-20"
                style={{ color: '#efbd1a' }}
                title={filePath ? "File Attached" : "Attach File"}
              ></i>
            </a>
          </div>
        );
      },
    },
     {
      Header: "Score Alloted",
      className: "text-center",
      Cell: ({ row }) => {
        const status = row.original.overall_status || 'Pending';
        const iconColor = status === 'Completed' ? 'text-success' : status === 'Pending' ? 'text-warning' : 'text-secondary';
        return (
          <Link to="#" onClick={() => handleViewMarks(row.original)}>
            <i className={`mdi mdi-eye font-size-18 ${iconColor}`} />
          </Link>
        );
      }
    },
    // {
    //   Header: "Assesment Status",
    //   className: "text-center",
    //   Cell: ({ row }) => (
    //     row.original.assessment_form ? (
    //       <a href={row.original.assessment_form} target="_blank" rel="noopener noreferrer">
    //         <i className="mdi mdi-file-document font-size-18 text-primary" />
    //       </a>
    //     ) : (
    //       <i className="mdi mdi-file-document font-size-18 text-muted" />
    //     )
    //   )
    // },
    { Header: "Name", accessor: "name" },
    { Header: "Email", accessor: "email" },
    { Header: "Position", accessor: "pos_desc" },
    { Header: "Pre Level", accessor: "experience" },
    { Header: "Pre Designation", accessor: "designation" },
    { Header: "Is Ex Emp", accessor: "already_worked" },
    { Header: "Period", accessor: "worked_period" },
    { Header: "Source", accessor: "through" },
    { Header: "Join Date", accessor: "exp_join_date" },
    { Header: "Ref By", accessor: "ref_by" },
    { Header: "Qualification", accessor: "qualification" },
    { Header: "Applied On", accessor: "created_dt" },
   
    {
      Header: "Status",
      accessor: "overall_status",
      Cell: ({ row }) => {
        const status = row.original.overall_status || 'Pending';
        const badgeColor = status === 'Completed' ? 'success' : status === 'Pending' ? 'warning' : 'secondary';
        return (
          <span className={`badge badge-soft-${badgeColor}`}>
            {status}
          </span>
        );
      }
    },
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      jobCode: "",
    },
    validationSchema: Yup.object({
      jobCode: Yup.object().nullable().required("Please Enter The Position"),
    }),
    onSubmit: (values) => {
      // console.log("Searching for position:", values.jobCode);
      const formData = new FormData()
      formData.append('position_id',values.jobCode?.value)
      formData.append('unit_id',authDetails?.unit_id)
      dispatch(fetchOnboradingProcessList(formData))
    },
  });

  const handleCancel=()=>{
    formik.resetForm()
    const formData = new FormData()
    formData.append('position_id',0)
    formData.append('unit_id',authDetails?.unit_id)
    dispatch(fetchOnboradingProcessList(formData))
  }

  return (
    <div className="page-content">
      <Loader loading={loading}/>
      <Container fluid>
        <Breadcrumbs title="Onboarding" breadcrumbItem="Process" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="mb-3 ">
                <Col md={4}>
                  <FormGroup>
                    <Label for="employee">Position</Label>
                    <CustomSelect
                      options={jobCodes.map(item => ({ value: item.position_id, label: item.position }))}
                      value={formik.values.jobCode}
                      onChange={selectedOption => formik.setFieldValue("jobCode", selectedOption)}
                      onBlur={() => formik.setFieldTouched("jobCode", true)} 
                    />
                    {formik.touched.jobCode && formik.errors.jobCode && (
                      <div className="text-danger ">{formik.errors.jobCode}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-center justify-content-end mob-center">
                  <Button type="submit" className="btn button-search  btn btn-secondary me-2"><i className="fas fa-search me-1"></i> Search</Button>
                  <Button type="button" className="btn button-cancel" onClick={handleCancel}><i className="fas fa-sync me-1" /> Cancel</Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={processList}
              isGlobalFilter={true}
              customPageSize={10}
              className="custom-table"
            />
          </CardBody>
        </Card>

        <Modal isOpen={marksModal} toggle={() => setMarksModal(!marksModal)} size="lg">
          <ModalHeader toggle={() => setMarksModal(!marksModal)}>Score Alloted Details</ModalHeader>
          <ModalBody>
            <Row className="mb-3">
              <Col md={4}>
                <Label>Applicant ID</Label>
                <Input type="text" value={selectedMarks?.applicant_id || ''} disabled className="mb-2" />
              </Col>
              <Col md={4}>
                <Label>Applicant Name</Label>
                <Input type="text" value={selectedMarks?.name || ''} disabled className="mb-2" />
              </Col>
            </Row>
            {applicantLevelDtls.length > 0 ? applicantLevelDtls.map((levelData, idx) => {
              const evalTypes = (levelData.evaluation_type || '').split(',').map(e => e.trim()).filter(Boolean);
              const evalMarks = (levelData.evaluation_mark || '').split(',').map(e => e.trim());
              return (
                  <div key={idx} className="mb-4">
                  <p className="mb-3 fw-bold" style={{color: '#f40808', fontSize: '14px'}}>
                    Level {levelData.level} &nbsp;| {levelLabelMap[String(levelData.level)] ?? 'N/A'}
                  </p>
                  <Row>
                    {evalTypes.map((evalType, i) => (
                      <Col md={4} key={i}>
                        <Label>{evalType}</Label>
                        <Input type="text" value={evalMarks[i] ?? ''} disabled className="mb-2" />
                      </Col>
                    ))}
                    <Col md={4}>
                      <Label>Status</Label>
                      <Input type="text" value={statusLabelMap[levelData.status] || ''} disabled className="mb-2" />
                    </Col>
                    <Col md={12}>
                      <Label>Comments</Label>
                      <Input type="textarea" value={levelData.Comments || ''} disabled className="mb-2" rows={2} />
                    </Col>
                  </Row>
                  {idx < applicantLevelDtls.length - 1 && <hr />}
                </div>
              );
            }) : (
              <p className="text-muted text-center">No score data available.</p>
            )}
          </ModalBody>
        </Modal>
      </Container>
    </div>
  );
};

export default Process;
